import { BoughtMoviesModel } from '../../pages/boughtMovies/query/types';
import getMoviePriceLabel from './getMoviePriceLabel';

const getStreamButtonPriceLabel = (
  movie: BoughtMoviesModel,
  stream: NonNullable<BoughtMoviesModel['stream']>
): string | React.JSX.Element  => {
  if (stream.license_type === 'subscription-stream') {
    return 'Film ansehen';
  }

  if (stream.price === 0 && !!stream.hours_to_expire) {
    return `Ausgeliehen FÜR ${stream.hours_to_expire}`;
  }

  return getMoviePriceLabel(
    movie,
    'stream',
    stream.welcome_bonus ? 'Jetzt gratis Abspielen' : 'LEIHEN FÜR ',
    stream.welcome_bonus ? '' : ' / 48 STD'
  );
};

export default getStreamButtonPriceLabel